<div>File is opened in a new tab.</div>
